import { Component, OnInit, TemplateRef } from '@angular/core';
import { AdminService } from './../../services/admin/admin.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { FormBuilder, FormArray, FormGroup } from '@angular/forms';
import { HelpersService } from 'src/app/shared/servicio/helpers/helpers.service';
import swal from 'sweetalert2';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { formatDate } from 'ngx-bootstrap';

@Component({
  selector: 'app-infologros',
  templateUrl: './infologros.component.html',
  styleUrls: ['./infologros.component.css'],
})
export class InfologrosComponent implements OnInit {
  datePickerConfig: Partial<BsDatepickerConfig>;

  constructor(
    private _admin: AdminService,
    private modalService: BsModalService,
    private formbuilder: FormBuilder,
    public _helper: HelpersService
  ) {
    this.datePickerConfig = Object.assign(
      {},
      { containerClass: 'theme-blue', dateInputFormat: 'YYYY-MM-DD' }
    );
  }

  metas: any = [];
  form: FormGroup;
  modalRef: BsModalRef;

  magnitude_type = '';
  metric = '';
  operator = '';
  is_active = '';
  magnitude: string = '';
  value: string = '';
  name: string = '';
  search = '';

  // Propiedades para metas escaladas
  isEscalada: boolean = false;
  levels: any[] = [{ magnitude: '', value: '' }];

  frequency: any;
  showLoading: boolean = true;

  date_start: Date;
  date_end: Date;

  page = 1;
  limit = 1;
  count = 0;
  config = {
    animated: true,
    class: 'modal-xl modal-dialog-centered',
    backdrop: true,
    ignoreBackdropClick: true,
  };
  configMetas = {
    animated: true,
    class: 'modal-xl modal-dialog-centered',
    backdrop: true,
    ignoreBackdropClick: true,
  };

  ngOnInit() {
    this.showLoading = true;
    this.initializeForm();
    this.getMetasList();
  }

  // Inicializar formulario para evitar undefined
  initializeForm() {
    this.form = this.formbuilder.group({
      magnitude: [''],
      magnitude_type: [''],
      metric: [''],
      name: [''],
      operator: [''],
      value: [''],
      is_active: [''],
      date_start_edit: [''],
      date_end_edit: [''],
      formula: [''],
      descripcion: [''],
      levels: this.formbuilder.array([])
    });
  }

  // Método trackBy para mejor rendimiento
  trackByMetaId(index: number, item: any): any {
    return item.id || index;
  }

  getMetasList() {
    this._admin
      .getMetas(this.page, this.search)
      .toPromise()
      .then((data) => {
        // LA CORRECCIÓN: Tu data ES el array directamente, no tiene wrapper
        if (Array.isArray(data)) {
          // Si data es directamente un array
          this.metas = data;
          this.count = data.length;
          this.limit = Math.ceil(data.length);
        } else if (data && data['results']) {
          // Si data tiene structure con results
          this.limit = Math.ceil(data['count']);
          this.count = data['count'];
          this.metas = data['results'];
        } else {
          // Fallback
          this.metas = [];
          this.count = 0;
          this.limit = 0;
        }

        this.showLoading = false;
      })
      .catch((error) => {
        console.log(error);
        this.metas = [];
        this.showLoading = false;
      });
  }

  pageChanged(p) {
    this.page = p.page;
    this.getMetasList();
  }

  async AbrirModalCrearMeta(template: TemplateRef<any>) {
    // Reiniciar valores para crear nueva meta
    this.resetFormularioCrear();
    this.modalRef = this.modalService.show(template, this.configMetas);
  }

  private resetFormularioCrear() {
    this.isEscalada = false;
    this.levels = [{ magnitude: '', value: '' }];
    this.name = '';
    this.magnitude_type = '';
    this.metric = '';
    this.operator = '';
    this.is_active = '';
    this.magnitude = '';
    this.value = '';
    this.date_start = null;
    this.date_end = null;
    this.initializeForm();
  }

  onDateChange(newDate: Date | string): void {
    if (!this.form) return;

    if (typeof newDate === 'string') {
      newDate = new Date(newDate);
    }

    const formattedDate = newDate.toISOString().split('T')[0];

    if (formattedDate !== this.form.get('date_start_edit').value) {
      this.form.patchValue({ date_start_edit: formattedDate });
    }
  }

  onDateChange2(newDate: Date | string): void {
    if (!this.form) return;

    if (typeof newDate === 'string') {
      newDate = new Date(newDate);
    }

    const formattedDate2 = newDate.toISOString().split('T')[0];

    if (formattedDate2 !== this.form.get('date_end_edit').value) {
      this.form.patchValue({ date_end_edit: formattedDate2 });
    }
  }

  // MÉTODO OPTIMIZADO PARA CHECKBOX ESCALADA
  onEscaladaChange() {
    console.log('Meta escalada cambiada a:', this.isEscalada);

    if (!this.isEscalada) {
      // Si se desactiva, resetear los niveles a uno vacío
      this.levels = [{ magnitude: '', value: '' }];
    } else {
      // Si se activa, asegurar que hay al menos un nivel
      if (!this.levels || this.levels.length === 0) {
        this.levels = [{ magnitude: '', value: '' }];
      }
    }
  }

  addLevel() {
    this.levels.push({ magnitude: '', value: '' });
  }

  removeLevel(index: number) {
    if (this.levels.length > 1) {
      this.levels.splice(index, 1);
    }
  }

  // Getter mejorado con verificaciones de seguridad
  get levelsFormArray(): FormArray {
    if (!this.form) {
      return this.formbuilder.array([]);
    }
    const levelsControl = this.form.get('levels');
    return levelsControl instanceof FormArray ? levelsControl : this.formbuilder.array([]);
  }

  addLevelToForm() {
    const levelGroup = this.formbuilder.group({
      magnitude: [''],
      value: ['']
    });
    this.levelsFormArray.push(levelGroup);
  }

  removeLevelFromForm(index: number) {
    const levelsArray = this.levelsFormArray;
    if (levelsArray && levelsArray.length > 1) {
      levelsArray.removeAt(index);
    }
  }

  updateLogro(id) {
    if (!this.form) {
      this._helper.modalError('Formulario no inicializado');
      return;
    }

    const formValues = this.form.value;
    const magnitude_type = formValues.magnitude_type;
    const metric = formValues.metric;
    const operator = formValues.operator;
    const is_active = parseInt(formValues.is_active); // CONVERTIR A NÚMERO
    const magnitude = formValues.magnitude;
    const value = formValues.value;
    const name = formValues.name;
    const date_start_edit = this.formatDate(formValues.date_start_edit);
    const date_end_edit = this.formatDate(formValues.date_end_edit);
    const levels = formValues.levels || [];

    // Determinar si es escalada basado en si tiene levels válidos
    const isEscaladaUpdate = Array.isArray(levels) && levels.length > 0 &&
      levels.some(level => level.magnitude && level.value);

    this._admin
      .logroUpdate(
        id,
        magnitude_type,
        metric,
        operator,
        is_active,
        magnitude,
        value,
        name,
        date_start_edit,
        date_end_edit,
        isEscaladaUpdate ? levels : null
      )
      .toPromise()
      .then(() => {
        swal({
          title: '<img src="assets/icons/good.png" width="80px" style="margin-top:0px;">',
          html: 'Logro actualizado correctamente',
          confirmButtonText: '<p style="margin-top:0px; margin-bottom:0px; font-family: \'coolvetica\';">Acepto</p>',
          confirmButtonColor: '#6eceee',
        });
        this.modalRef.hide();
        this.getMetasList();
      })
      .catch((error) => {
        console.error('Error al actualizar logro:', error);
        this._helper.modalError('Error al actualizar logro');
      });
  }

  formatDate(date) {
    if (!date) {
      return '';
    }
    const formattedDate = new Date(date);
    return formattedDate.toISOString().slice(0, 10);
  }

  crearMeta() {
    // Validaciones básicas mejoradas
    if (!this.name.trim()) {
      this._helper.modalError('El nombre es requerido');
      return;
    }

    if (!this.metric) {
      this._helper.modalError('La métrica es requerida');
      return;
    }

    if (!this.operator) {
      this._helper.modalError('El operador es requerido');
      return;
    }

    if (!this.magnitude_type) {
      this._helper.modalError('El tipo de magnitud es requerido');
      return;
    }

    if (!this.date_start || !this.date_end) {
      this._helper.modalError('Las fechas son requeridas');
      return;
    }

    if (this.is_active === '') {
      this._helper.modalError('El estado es requerido');
      return;
    }

    // Validar fechas
    if (this.date_end.getTime() < this.date_start.getTime()) {
      this._helper.modalError('La fecha final no puede ser menor que la fecha inicial');
      return;
    }

    // Validaciones específicas según el tipo
    if (this.isEscalada) {
      const validLevels = this.levels.filter(level => level.magnitude.trim() && level.value.trim());
      if (validLevels.length === 0) {
        this._helper.modalError('Debe agregar al menos un nivel válido para metas escaladas');
        return;
      }
      this.levels = validLevels; // Usar solo niveles válidos
    } else {
      if (!this.magnitude.trim()) {
        this._helper.modalError('La magnitud es requerida para metas normales');
        return;
      }
      if (!this.value.trim()) {
        this._helper.modalError('El valor es requerido para metas normales');
        return;
      }
    }

    // Formatear fechas
    const init = this.formatDateForRequest(this.date_start);
    const end = this.formatDateForRequest(this.date_end);

    // Preparar y ejecutar petición
    let request$;
    if (this.isEscalada) {
      const metaData = {
        name: this.name.trim(),
        metric: this.metric,
        operator: this.operator,
        magnitude_type: this.magnitude_type,
        date_start: init,
        date_end: end,
        is_active: this.is_active,
        levels: this.levels
      };
      request$ = this._admin.crearMeta(metaData, true);
    } else {
      request$ = this._admin.crearMeta(
        this.magnitude_type,
        this.metric,
        this.operator,
        this.is_active,
        this.magnitude.trim(),
        this.value.trim(),
        this.name.trim(),
        init,
        end
      );
    }

    // Ejecutar petición
    request$.subscribe({
      next: () => this.metaCreadaConExito(),
      error: (error) => {
        console.error('Error al crear meta:', error);
        this._helper.modalError('Error al crear meta. Por favor, intente nuevamente.');
      }
    });
  }

  private formatDateForRequest(date: Date): string {
    if (!date) return '';

    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);

    return `${year}-${month}-${day}`;
  }

  private metaCreadaConExito() {
    swal({
      title: '<img src="assets/icons/good.png" width="80px" style="margin-top:0px;">',
      html: 'Meta creada exitosamente',
      confirmButtonText: '<p style="margin-top:0px; margin-bottom:0px; font-family: \'coolvetica\';">Acepto</p>',
      confirmButtonColor: '#6eceee',
    });

    this.getMetasList();
    this.modalRef.hide();
    this.resetFormularioCrear();
  }

  // 1. CORRECCIÓN DEL MÉTODO AbrirModal (lógica de magnitud corregida)

  async AbrirModal(template: TemplateRef<any>, item) {
    this.showLoading = true;
    this.metas.id = item.id;

    this._admin
      .getMetaDetail(item.id)
      .toPromise()
      .then((data: any) => {
        console.log('Detalle recibido:', data);

        // CORRECCIÓN: Verificar si es escalada basándose en levels Y is_tiered
        this.isEscalada = (data.levels && Array.isArray(data.levels) && data.levels.length > 0) || data.is_tiered;

        // Crear FormArray para levels
        let levelsArray = [];
        if (this.isEscalada && data.levels && data.levels.length > 0) {
          levelsArray = data.levels.map(level => this.formbuilder.group({
            magnitude: [level.magnitude || ''],
            value: [level.value ? level.value.toString() : '']
          }));
        }

        // CORRECCIÓN: La magnitud se llena SOLO si NO es escalada
        const magnitudValue = this.isEscalada ? '' : (data.magnitude || '');
        const valorValue = this.isEscalada ? '' : (data.value ? data.value.toString() : '');

        this.form = this.formbuilder.group({
          magnitude: [magnitudValue],                               // Solo se llena si NO es escalada
          magnitude_type: [data.magnitude_type || ''],
          metric: [data.metric || ''],
          name: [data.name || ''],
          operator: [data.operator || ''],
          value: [valorValue],                                      // Solo se llena si NO es escalada
          is_active: data.is_active ? '1' : '0',
          date_start_edit: [data.date_start || ''],
          date_end_edit: [data.date_end || ''],
          formula: [data.formula || ''],
          descripcion: [data.descripcion || ''],
          levels: this.formbuilder.array(levelsArray)
        });

        this.modalRef = this.modalService.show(template, this.config);
        this.showLoading = false;
      })
      .catch((error) => {
        console.log('Error al cargar detalle:', error);
        this.showLoading = false;
        this.initializeForm();
      });
  }
}
